module.exports = __webpack_public_path__ + "static/media/dark_icn_map_pin_bus_lex_selected.df50113e.svg";